module.exports = __webpack_public_path__ + "img/Img26b_159308_CeEt-8-1A8-19.84e24a10.jpg";